import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Read items
export function* readItemsRequest() {
    yield takeEvery(actions.SHOEBOX_READ_ITEMS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/shoebox/items', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SHOEBOX_READ_ITEMS_SUCCESS,
                shoeboxItems: data.shoebox_items,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.SHOEBOX_READ_ITEMS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readItemsSuccess() {
    yield takeEvery(actions.SHOEBOX_READ_ITEMS_SUCCESS, () => {});
}
export function* readItemsError() {
    yield takeEvery(actions.SHOEBOX_READ_ITEMS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read
export function* readItemRequest() {
    yield takeEvery(actions.SHOEBOX_READ_ITEM_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/shoebox/items/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.SHOEBOX_READ_ITEM_SUCCESS,
                shoeboxItem: data.shoebox_item,
            });
        }
        catch (error) {
            yield put({
                type: actions.SHOEBOX_READ_ITEM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readItemSuccess() {
    yield takeEvery(actions.SHOEBOX_READ_ITEM_SUCCESS, () => {});
}
export function* readItemError() {
    yield takeEvery(actions.SHOEBOX_READ_ITEM_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete
export function* deleteItemRequest() {
    yield takeEvery(actions.SHOEBOX_DELETE_ITEM_REQUEST, function* ({ ids }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/shoebox/items`, ids, context);

            yield put({
                type: actions.SHOEBOX_DELETE_ITEM_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.SHOEBOX_DELETE_ITEM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteItemSuccess() {
    yield takeEvery(actions.SHOEBOX_DELETE_ITEM_SUCCESS, function* () {
        yield message.success(t`The item is deleted.`);
    });
}
export function* deleteItemError() {
    yield takeEvery(actions.SHOEBOX_DELETE_ITEM_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readItemsRequest),
        fork(readItemsSuccess),
        fork(readItemsError),
        fork(readItemRequest),
        fork(readItemSuccess),
        fork(readItemError),
        fork(deleteItemRequest),
        fork(deleteItemSuccess),
        fork(deleteItemError),
    ]);
}
